module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Down-right-3a01e173a161376aa51b94ff60c3c7e3.svg";